"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBackboneClass = exports.isCollection = exports.isModel = exports.enhanceBackboneClassWithBrigade = exports.getCollectionsFromProps = exports.getModelsFromProps = exports.MODEL_EVENTS = exports.COLLECTION_EVENTS = exports.BRIGADE_MODEL_KEY = void 0;

var _backbone = _interopRequireDefault(require("backbone"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BRIGADE_MODEL_KEY = '__SECRET_BRIGADE_MODEL_KEY__';
exports.BRIGADE_MODEL_KEY = BRIGADE_MODEL_KEY;
var COLLECTION_EVENTS = 'add change remove reset';
exports.COLLECTION_EVENTS = COLLECTION_EVENTS;
var MODEL_EVENTS = 'change';
exports.MODEL_EVENTS = MODEL_EVENTS;

var getModelsFromProps = function (data) {
  if (data === void 0) {
    data = {};
  }

  return Object.keys(data).reduce(function (accumulator, key) {
    var value = data[key];

    if (isModel(value)) {
      enhanceBackboneClassWithBrigade(value, key);
      accumulator.push(value);
    }

    return accumulator;
  }, []);
};

exports.getModelsFromProps = getModelsFromProps;

var getCollectionsFromProps = function (data) {
  if (data === void 0) {
    data = {};
  }

  return Object.keys(data).reduce(function (accumulator, key) {
    var value = data[key];

    if (isCollection(value)) {
      enhanceBackboneClassWithBrigade(value, key);
      accumulator.push(value);
    }

    return accumulator;
  }, []);
};

exports.getCollectionsFromProps = getCollectionsFromProps;

var enhanceBackboneClassWithBrigade = function (backboneClass, key) {
  if (!isBackboneClass(backboneClass)) return backboneClass;
  backboneClass[BRIGADE_MODEL_KEY] = key;
  return backboneClass;
};

exports.enhanceBackboneClassWithBrigade = enhanceBackboneClassWithBrigade;

var isModel = function (obj) {
  return obj && obj instanceof _backbone.default.Model;
};

exports.isModel = isModel;

var isCollection = function (obj) {
  return obj && obj instanceof _backbone.default.Collection;
};

exports.isCollection = isCollection;

var isBackboneClass = function (obj) {
  return isModel(obj) || isCollection(obj);
};

exports.isBackboneClass = isBackboneClass;